import React from "react";

import { Grid, GridCol } from "../../../../components/Grid";
import { Card } from "../../components/Card";
// components
import { Layout, Row } from "../../components/Layout";

// Config
import Config from "../../Config";
import CohortFactorHeatmap from "./Cards/CohortFactorHeatmap";
import CohortsSatisfaction from "./Cards/CohortsSatisfaction";
import SatisfactionFactors from "./Cards/SatisfactionFactors";

const Cohorts = () => {
	return (
		// topAreaMaxHeight is the height of the top area of the layout that gets the grey background
		<Layout title="Cohorts" topAreaMaxHeight={448}>
			<Row height={Config.COHORTS.ROW_HEIGHTS[0]}>
				<Grid gap={2} cols={12} padding={0}>
					<GridCol span={7}>
						<Card height={Config.COHORTS.ROW_HEIGHTS[0]}>
							<CohortsSatisfaction />
						</Card>
					</GridCol>
					<GridCol span={5}>
						<Card height={Config.COHORTS.ROW_HEIGHTS[0]}>
							<SatisfactionFactors />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={Config.COHORTS.ROW_HEIGHTS[1]}></Row>
			<Row height={Config.COHORTS.ROW_HEIGHTS[2]}>
				<div>
					<Grid gap={2} cols={12} padding={0}>
						<GridCol span={12}>
							<Card testId="cohort-satisfaction-card" minHeight={Config.COHORTS.ROW_HEIGHTS[2]}>
								<CohortFactorHeatmap />
							</Card>
						</GridCol>
					</Grid>
				</div>
				<Row height={56} />
			</Row>
		</Layout>
	);
};

export default Cohorts;
